import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shared/dist/js/components/custom-404.js");
